import './index.css';
import accompanimentList from './components/accompanimentList.ts';
import competitionForm from './components/competitionForm.ts';
import copyFields from './components/copyFields.ts';
import copyToClipboard from './components/copyToClipboard.ts';
import dialog from './components/dialog.ts';
import expandablePill from './components/expandablePill.ts';
import formValidation from './components/formValidation.ts';
import guide from './components/guide.ts';
import homeFeaturesScroll from './components/homeFeaturesScroll.ts';
import homeTabs from './components/homeTabs.ts';
import imageGallery from './components/imageGallery.ts';
import lightbox from './components/lightbox.ts';
import loginTimer from './components/loginTimer.ts';
import memberList from './components/memberList.ts';
import mobileHeader from './components/mobileHeader.ts';
import openDialog from './components/openDialog.ts';
import pickPerson from './components/pickPerson.ts';
import racesOverview from './components/racesOverview.ts';
import scrollUpButton from './components/scrollUpButton.ts';
import selectUnit from './components/selectUnit.ts';
import tabs from './components/tabs.ts';
import teamCard from './components/teamCard.ts';
import teamList from './components/teamList.ts';
import tiptapEditor from './components/tiptapEditor.ts';
import unitMemberPicker from './components/unitMemberPicker.ts';
import { replaceIcons } from './icons.ts';
import { setupBfCacheProtection } from './utils/bfCacheProtection.ts';

type Component = (node: HTMLElement) => void;

const components: Record<string, Component> = {
  accompanimentList,
  competitionForm,
  copyFields,
  copyToClipboard,
  dialog,
  expandablePill,
  formValidation,
  guide,
  homeFeaturesScroll,
  homeTabs,
  imageGallery,
  lightbox,
  loginTimer,
  memberList,
  mobileHeader,
  openDialog,
  pickPerson,
  racesOverview,
  scrollUpButton,
  selectUnit,
  tabs,
  teamCard,
  teamList,
  tiptapEditor,
  unitMemberPicker,
};

const componentNodes =
  document.querySelectorAll<HTMLElement>('[data-component]');

componentNodes.forEach((node) => {
  const componentNames =
    node.dataset.component?.split(',').map((name) => name.trim()) ?? [];
  for (const componentName of componentNames) {
    if (components[componentName]) {
      components[componentName](node);
    } else {
      console.warn(`Component "${componentName}" not found.`);
    }
  }
});

// Replace icons after all components are initialized
replaceIcons();

setupBfCacheProtection();

// Handle browser back/forward navigation for dialogs
let previousHash = window.location.hash;
window.addEventListener('hashchange', () => {
  const currentHash = window.location.hash;

  // If hash was removed or changed, close the dialog that had the old hash
  if (previousHash && previousHash !== currentHash) {
    const dialogId = previousHash.slice(1); // Remove '#'
    const dialog = document.getElementById(
      dialogId,
    ) as HTMLDialogElement | null;
    if (dialog?.open) {
      dialog.close();
    }
  }

  previousHash = currentHash;
});
